import type { SiteConfig } from '../../@types/context/site-config.types';
import { insuranceMypageNo } from './insurance-mypage.config';

export const sitePathGeminiNoConfig: Pick<SiteConfig, 'path'> = {
  path: {
    loansApply: '/soknad/forbrukslan',
    loansPreForm: '/nb/lan/forbrukslan',
    mypage: '/mine-tilbud',
    mypageOverview: '/mine-tilbud',
    mypageLoans: '/mine-tilbud/forbrukslan',
    mypageCreditCards: '/mine-tilbud/kredittkort',
    mypageSecuredLoans: '/mine-tilbud/lan-med-sikkerhet',
    creditCard: '/kredittkort/sok',
    insurance: '/soknad/forsikring',
    oneFormPreflight: '/soknad/forhandssjekk',
    oneFormApply: '/soknad/lan',
    oneFormRecommendations: '/soknad/lan/anbefalinger',
    ...insuranceMypageNo,
  },
};
